/* eslint-disable react/prop-types */
import { cn } from "@/lib/utils";
import axios from "axios";
import { Confirm } from "notiflix";
import { Loading } from "notiflix";
import { useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { IoCopyOutline } from "react-icons/io5";
import { toast } from "sonner";
import bg from "@/assets/pattern.png";
import { useSelector } from "react-redux";
import { PostRequest } from "@/lib/http";
import { cardBg, cardBg2 } from "@/assets";
import { useEffect } from "react";

const VirtualAccount = () => {
  const user = useSelector((state) => state.user.user);
  const [tooltip, setTooltip] = useState(false);
  const hasAccount = user.account_number && user.bank_name && user.account_name;

  const copyToClipboard = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setTooltip(true);
        setTimeout(() => {
          setTooltip(false);
        }, 4000); // Hide tooltip after 2 seconds
      })
      .catch((error) => {
        console.error("Error copying to clipboard:", error);
      });
  };

  async function requestAccount() {
    try {
      Loading.standard("Sending Request");

      const { err } = await PostRequest({
        url: `/api/dva/${user.id}`,
        errorMessage: "Failed to request virtual account",
      });

      if (err) {
        toast.error(err, {
          duration: 10000,
          dismissible: true,
        });
      } else {
        window.location.reload();
        toast.success(
          "Request successful, if details does not reflect shortly, kindly refresh the page",
          {
            duration: 10000,
            dismissible: true,
          },
        );
      }
    } catch (error) {
      toast.error(error.response?.data?.err || "An error occurred");
    } finally {
      Loading.remove();
    }
  }

  useEffect(() => {
    if (!hasAccount && !localStorage.getItem("request_dva_prompt")) {
      Confirm.show(
        "Request Virtual Account",
        "We recommend you get a Dedicated Virtual account for quick and easy funding. Do you want to request for one?",
        "Yes",
        "No",
        () => {
          localStorage.setItem("request_dva_prompt", "true");
          requestAccount();
        },
        () => {},
      );
    }
  }, []);
  return (
    <div
      className={cn(
        "font-manrope flex flex-col justify-between gap-5 rounded-xl p-5 text-white shadow",
        {
          "gap-6 rounded-[20px]": hasAccount,
        },
      )}
      style={{
        backgroundImage: `url(${cardBg2})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      // style={{
      //   background: `linear-gradient(rgb(57 94 172), rgb(57 94 172)), url('${bg}')`,
      //   backgroundBlendMode: "overlay",
      //   backgroundSize: "cover",
      // }}
    >
      {hasAccount ? (
        <>
          <div className="flex items-center justify-between">
            <h2 className="text-base font-bold">Virtual Account</h2>

            <h2 className="text-xl font-bold">{user.bank_name}</h2>
          </div>

          <div
            onClick={() => copyToClipboard(user.account_number)}
            className="flex w-fit items-center gap-2 rounded-full bg-white/15 p-3 px-4 pr-5"
          >
            <h1 className="text-2xl font-bold">{user.account_number}</h1>

            {tooltip ? (
              // <div>
              //   <AiFillCheckCircle
              //     size={25}
              //     // className="text-[#2fc222]"
              //     cursor="pointer"
              //   />
              // </div>
              <p className="text-[20px]">✅</p>
            ) : (
              <IoCopyOutline size={20} cursor="pointer" />
            )}
          </div>

          <h2 className="font-bold">{user.account_name}</h2>
        </>
      ) : (
        <>
          <h1 className="text-xl font-bold">Virtual Account</h1>
          <p className="font-semibol text-[0.9em] leading-[1.2] opacity-70">
            You don&apos;t have a dedicated virtual account number yet. Virtual
            Account allows you to fund you wallet simply by transferring to the
            account number.
          </p>
          {/* <p className="text-[0.9em] font-semibold leading-[1.2] opacity-70">
            This feature is coming soon so please stay tuned
          </p> */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // return toast.warning(
              //   "This feature isnt available at the moment please check again later",
              // );
              Confirm.show(
                "Confirm Action",
                "Do you want to request a dedicated virtual account number?",
                "Proceed",
                "Cancel",
                requestAccount,
              );
            }}
          >
            <button
              className={`bg-primary w-full rounded-xl border border-white p-2 font-semibold text-white`}
              type="submit"
            >
              Request Account Number
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default VirtualAccount;
